











































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue'
import CompRadioButton  from '@/components/common/CompRadioButton.vue'
import {ClaimOption, GetClaimsNo} from 'supporter';
import {ClaimType} from '@/types/claim';
import {popupResize} from '@/utils/ncp';

@Component({
  components: {
    CompSelectBox,
    CompRadioButton
  },
  computed: {
    isExchangeClaim(){
      return this.claimType === ClaimType.EXCHANGE
    },
    isReturnClaim(){
      return this.claimType === ClaimType.RETURN
    },
  }
})
export default class CollectReturnPopup extends Vue {
  private refundOnHoldSelectList = [
    {
      name: 'CLAIM_POPUP_SELECT',
      value: '',
    },
    {
      name: 'CLAIM_POPUP_COLLECT_COMPLETE_PROCESS',
      value: false,
    },
    {
      name: 'CLAIM_POPUP_COLLECT_COMPLETE_HOLD',
      value: true,
    },
  ]
  private requestAmtRadioOptions = {
    name: 'requestAmt',
    data: [
      {
        id: 'requestAmt_false',
        value: false,
        dispaly: 'CLAIM_POPUP_INPUT_DISABLE'
      },
      {
        id: 'requestAmt_true',
        value: true,
        dispaly: 'CLAIM_POPUP_INPUT_ABLE'
      }
    ]
  };

  private showRequestAmtInput = false
  private getClaimsNoResponseData: GetClaimsNo = {} as any
  private claimNo:string = ''
  private claimType: string = ''
  private claimedOptions: ClaimOption[] = []
  private formData = {
    restoreStockOrderOptionNos: [],
    refundOnHold: '',
    refundHoldProposedAmt: '',
    refundOnHoldReason: ''
  }

  @Watch('formData.refundOnHold')
  @Watch('showRequestAmtInput')
  resetRefundHoldProposedAmt(){
    this.formData.refundHoldProposedAmt = ''
    this.$nextTick(()=>{
      popupResize()
    })
  }

  // 다른 formData의 값이 바꼈을 때, ',' 위치가 바뀌는 이슈 때문에 keyup이벤트 대신 watch로 적용
  @Watch('formData.refundHoldProposedAmt')
  protected onlyCommaNumber(newValue) {
    const result = newValue.replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    this.$nextTick(() => this.formData.refundHoldProposedAmt = result);
  }

  private get checkAll(): boolean {
    if (!this.claimedOptions) {
      return false;
    }

    return this.formData.restoreStockOrderOptionNos.length === this.claimedOptions.length;
  }
  private set checkAll(checked: boolean){
    let selected = []
    if(checked) {
      selected = this.claimedOptions.map((claimedOption) => claimedOption.orderOptionNo);
    }

    this.formData.restoreStockOrderOptionNos = [...selected];
  }

  created(){
    this.fetchAndSetClaimNoResponse()
  }

  async fetchAndSetClaimNoResponse(): Promise<void>{
    const {data} = await this.$api.getClaimsNo({ pathParams: {no: this.$route.query.claimNo.toString()}})

    this.claimNo = this.$route.query.claimNo.toString()
    this.getClaimsNoResponseData = data;
    this.claimType = data.claimType
    this.claimedOptions = data.claimedOptions

    this.$nextTick(()=>{
      popupResize()
    })
  }

  onSubmit(): void{
    if(!this.validation()){
      return
    }

    const apiMap = {
      [ClaimType.EXCHANGE]: () => this.$api.putReturnExchangesNoCollect({
        pathParams: {
          no: this.$route.query.claimNo.toString(),
        },
        data: {
          restoresStock: this.checkAll,
        },
      }),
      [ClaimType.RETURN]: () => this.$api.putReturnsNoCollect({
        pathParams: {
          no: this.$route.query.claimNo.toString()
        },
        data: {
          refundOnHoldReason: this.formData.refundOnHoldReason.trim().length === 0 ? null : this.formData.refundOnHoldReason.trim(),
          restoreStockOrderOptionNos: this.formData.restoreStockOrderOptionNos,
          refundOnHold: this.formData.refundOnHold as any, // boolean 데이터인데, selectBox는 3가지라 any 처리
          refundHoldProposedAmt: Number(this.removeComma(this.formData.refundHoldProposedAmt)),
        }
      })
    }

    apiMap[this.claimType]()
        .then(res => {
          alert(this.$t('CLAIM_POPUP_PROCESS_SUCCESS_MESSAGE'))
          this.reSearch()
          this.onClose()
        })
  }

  private validation(): boolean{
    switch(this.claimType){
      case ClaimType.RETURN: {
        if(this.formData.refundOnHold === ''){
          alert(this.$t('CLAIM_POPUP_SELECT_REFUND_ITEM_MESSAGE'))
          return false;
        }

        // '수거완료(환불보류)' 이면서 '요청금액 입력함' 체크
        if(this.formData.refundOnHold && this.showRequestAmtInput){
          const refundHoldProposedAmt = this.removeComma(this.formData.refundHoldProposedAmt)
          if(refundHoldProposedAmt === ''){
            alert(this.$t('CLAIM_POPUP_WRITE_AMOUNT_MESSAGE'))
            return false;
          }
        }

        if(this.formData.refundOnHold && this.formData.refundOnHoldReason.trim() === '') {
          alert(this.$t('CLAIM_POPUP_WRITE_REFUND_REASON_MESSAGE'))
          return false;
        }

        const confirmMessage = this.formData.refundOnHold ? this.$t('CLAIM_POPUP_ASK_REFUND_HOLD_MESSAGE') : this.$t('CLAIM_POPUP_ASK_COLLECT_COMPLETE_MESSAGE');
        if(!confirm(confirmMessage as string)){
          return false
        }
        break;
      }

      case ClaimType.EXCHANGE: {
        if(!confirm(this.$t('CLAIM_POPUP_ASK_COLLECT_COMPLETE_MESSAGE') as string)){
          return false
        }
        break;
      }
    }

    return true;
  }

  private onClose(){
    window.close()
  }

  private reSearch(){
    if (this.$route.query && this.$route.query.callback) {
      $(window.opener.location).attr('href', `javascript:window.${this.$route.query.callback}('1');`);
    }
  }

  protected mounted() {
    this.$nextTick(() => {
      document.body.classList.add('popup_medium');
      popupResize();
    });
  }

  private removeComma(amountWithComma: string): string{
    return amountWithComma.replace(/,/gi, '');
  }
}
